import Vue from "vue";
import TheCard from '@/components/TheCard.vue';
import RegistrationTitle from '@/components/RegistrationTitle';
import TitlePage from '@/components/TitlePage.vue';
import FlipCheck from '@/components/FlipCheck';
import LoadingSection from '@/components/LoadingSection';

Vue.mixin({
  components: {
    TheCard,
    TitlePage,
    FlipCheck,
    LoadingSection,
    RegistrationTitle,
  },
});